import script from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerPriceOffer.vue?vue&type=script&setup=true&lang=js"

import "./SellerPriceOffer.vue?vue&type=style&index=0&id=6d697b65&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d697b65"]])

export default __exports__